import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-click-to-call',
  templateUrl: './click-to-call.component.html',
  styleUrls: ['./click-to-call.component.css']
})
export class ClickToCallComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  callNow(){
    window.location.href = "tel:+919696683999";
  }

}
